import index from './time'

export default index